import React from 'react';
import theme from './Pagination.module.scss';
import { PaginationState, calculatePageRange } from '.';
import { Trans } from '@lingui/react/macro';
import { range } from 'lodash-es';
import { Button } from '@/components/Buttons';

interface PaginationProps {
    value: PaginationState;
    showFirstLastButtons?: boolean;
    showPreviousNextButtons?: boolean;
    pagesToDisplay?: number;
}

const Pagination: React.FC<PaginationProps> = ({ value, pagesToDisplay = 7 }) => {
    // const startPage = Math.max(0, value.currentPage - (pagesToDisplay - 1) / 2);
    // const endPage = Math.max(0, value.currentPage + (pagesToDisplay - 1) / 2);

    const pageRange = calculatePageRange(value.currentPage, value.numberOfPages, pagesToDisplay);
    const pages = range(pageRange.start, pageRange.end + 1);

    return (
        <div className={theme.pagination}>
            <div className={theme.info}>
                <Trans>
                    Showing&nbsp;
                    <strong>
                        {value.displayedEntries.start + 1} to {Math.min(value.displayedEntries.end + 1, value.totalEntries)}{' '}
                        of {value.totalEntries}&nbsp;
                    </strong>
                    entries
                </Trans>
            </div>

            <div className={theme.pages}>
                <Button onClick={(e) => value.setPage(0)}>&lt;&lt;</Button>
                <Button onClick={(e) => value.setPage(value.currentPage - 1)}>&lt;</Button>
                {pages.map((i) => (
                    <Button
                        onClick={(e) => value.setPage(i)}
                        key={i}
                        className={i === value.currentPage ? theme.active : undefined}>
                        {i + 1}
                    </Button>
                ))}
                <Button onClick={(e) => value.setPage(value.currentPage + 1)}>&gt;</Button>
                <Button onClick={(e) => value.setPage(value.numberOfPages - 1)}>&gt;&gt;</Button>
            </div>
        </div>
    );
};

export default Pagination;
